var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-delivery"},[_c('h2',[_vm._v("Delivery options")]),_c('b-row',_vm._l((_vm.deliveryMethods),function(deliveryMethod){return _c('b-col',{key:deliveryMethod.id,attrs:{"lg":"3"}},[_c('div',{staticClass:"payment-option",class:{
          selectDeliveryMethodStyle:
            _vm.selectDeliveryMethodStyle(deliveryMethod),
        },on:{"click":function($event){return _vm.selectDeliveryMethod(deliveryMethod)}}},[_c('img',{attrs:{"src":deliveryMethod.img,"alt":""}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }